// extracted by mini-css-extract-plugin
export default {"overlay":"i20ArH","title":"XBxOtT","comingSoon":"o7Glmh"};